import React from "react";
import Banner from "./../../components/Banner";
import { Sidebar } from "./../../components/Sidebar";
import Balance from "./Balance";
import Footer from "./../../components/Footer";
import AccountStatus from "./AccountStatus";

export const Account = () => {
  const companyProfileId = window.sessionStorage.getItem("companyProfileId");
  const individualProfileId = window.sessionStorage.getItem(
    "individualProfileId"
  );
  const isIndividual = React.useMemo(() => {
    if (!!Number(individualProfileId)) {
      return true;
    }
    if (!!Number(companyProfileId)) {
      return false;
    }
    return false;
  }, [individualProfileId, companyProfileId]);
  return (
    <div className="min-h-screen h-dvh flex justify-between bg-white">
      <Sidebar />
      <div className="min-h-screen w-[85%] flex flex-col">
        <Banner title="View Account" />
        {isIndividual ? <Balance /> : <AccountStatus />}
        <Footer />
      </div>
    </div>
  );
};
